import { getEnv } from 'common-nextjs';
import fireGtagEvent from '~/services/analytics/fireGtagEvent';
import { setupAllAnalyticsLocalCapture } from '~/services/analytics/setupLocalCapture';

export default function analyticsInitialize() {
  setupAllAnalyticsLocalCapture();

  fireGtagEvent('js', new Date());

  if (getEnv() == 'production') {
    if (getEnv('GA_TRACKING_ID')) {
      fireGtagEvent('config', getEnv('GA_TRACKING_ID'), {
        send_page_view: false,
      });
    }

    if (getEnv('GA4_TRACKING_ID')) {
      fireGtagEvent('config', getEnv('GA4_TRACKING_ID'), {
        send_page_view: false,
      });
    }

    if (getEnv('ADWORDS_KEY')) {
      fireGtagEvent('config', getEnv('ADWORDS_KEY'), {
        send_page_view: false,
      });
    }
  } else {
    console.log('Analytics initialized, but only in production.');
  }
}
